import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

export type InputProps = {}

export type Variables = {}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

export const COMPANY_LOGO_QUERY = gql`
  query getCompanyLogo {
    getCompanyLogo
  }
`

const withCompanyLogoQuery = graphql<InputProps, Response, Variables, ChildProps>(
  COMPANY_LOGO_QUERY,
  {
    name: 'companyLogoData',
  },
)

export default withCompanyLogoQuery
